import { FC, useCallback, useContext } from 'react'
import { RouteComponentProps } from 'react-router'
import { Redirect, Route, Switch } from 'react-router-dom'
import useLocalStorage from '@rehooks/local-storage'
import { ConnectedUser } from '@ucc/admin-global-state'

import config from 'config'
import { useAccountContext } from './contexts/AccountContext'
import { DefaultPageContext } from './providers/DefaultPageProvider'

// All the base/layout routes go here
const BaseRoutes: FC = ({ children }) => {
  const { accountKey: currentAccountKey } = useAccountContext()
  const [iAmInfos] = useLocalStorage<ConnectedUser>(config.I_AM_TOKEN_KEY)
  const { defaultPage } = useContext(DefaultPageContext)

  const IsAccountKey = useCallback((value?: string) => {
    return !!value && /^\d+$/.test(value)
  }, [])

  const redirectToRouteWithAccountKey = useCallback(
    (props?: RouteComponentProps<any>) => {
      if (iAmInfos?.accountKey || currentAccountKey) {
        const pathName = props ? props.location.pathname + props.location.search : defaultPage
        const accountKey = currentAccountKey ? currentAccountKey : iAmInfos?.accountKey
        return <Redirect to={`/${accountKey}${pathName}`} />
      }
    },
    [iAmInfos?.accountKey, currentAccountKey, defaultPage],
  )

  return (
    <Switch>
      <Route exact path="/authenticate/callback" component={() => <Redirect to="/" />} />
      <Route
        exact
        path="/:accountKey"
        render={(props) => {
          if (IsAccountKey(props?.match.params.accountKey)) {
            return <Redirect to={`/${props.match.params.accountKey}/${defaultPage}`} />
          }
          return redirectToRouteWithAccountKey(props)
        }}
      />
      <Route
        path="/:accountKey"
        render={(props) => {
          if (IsAccountKey(props?.match.params.accountKey)) {
            return <>{children}</>
          }
          return redirectToRouteWithAccountKey(props)
        }}
      />
      {/* we still want to display the layout on root */}
      <Route path="/">{children}</Route>
    </Switch>
  )
}

export default BaseRoutes
